"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pxValue = exports.getLayoutProps = exports.Layout = exports.Grid = exports.Flex = exports.Box = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Reusable css that adds the followign properties to a styled component:
 * $m (number (in pixels) or string) : margin
 * $mx (number (in pixels) or string) : margin-left and margin-right
 * $my (number (in pixels) or string) : margin-top and margin-bottom
 * $mt (number (in pixels) or string) : margin-top
 * $mb (number (in pixels) or string) : margin-bottom
 * $ml (number (in pixels) or string) : margin-left
 * $mr (number (in pixels) or string) : margin-right
 * $p (number (in pixels) or string) : padding
 * $px (number (in pixels) or string) : padding-left and padding-right
 * $py (number (in pixels) or string) : padding-top and padding-bottom
 * $pt (number (in pixels) or string) : padding-top
 * $pb (number (in pixels) or string) : padding-bottom
 * $pl (number (in pixels) or string) : padding-left
 * $pr (number (in pixels) or string) : padding-right
 * $d (string) : display (css property)
 * $f (string or number) : flex (for example flex: 1)
 * $fd (string) : flex-direction (for example flex-direction: column)
 * $column (string) : grid-column
 * $row (string) : grid-row
 * $mw (number (in pixels) or string) : max-width
 * $w (number (in pixels) or string) : width
 * $h (number (in pixels) or string) : height
 * DEPRECATED - $align is deprecated in favour of $alignSelf
 * $align (string) : align-self (for example align-self: center)
 * $alignSelf (string) : align-self (for example align-self: center)
 * $justify (string) : justify-self (for example justify-self: center)
 * $textAlign (string) : text-align (for example text-align: center)
 * $overflow (string) : overflow (for example overflow: hidden)
 */
var Layout = (0, _styledComponents.css)(["margin:", ";margin-left:", ";margin-right:", ";margin-top:", ";margin-bottom:", ";padding:", ";padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";display:", ";flex:", ";grid-column:", ";grid-row:", ";max-width:", ";width:", ";height:", ";align-self:", ";align-self:", ";justify-self:", ";text-align:", ";overflow:", ";"], function (props) {
  return pxValue(props.$m);
}, function (props) {
  var _props$$ml;

  return pxValue((_props$$ml = props.$ml) !== null && _props$$ml !== void 0 ? _props$$ml : props.$mx);
}, function (props) {
  var _props$$mr;

  return pxValue((_props$$mr = props.$mr) !== null && _props$$mr !== void 0 ? _props$$mr : props.$mx);
}, function (props) {
  var _props$$mt;

  return pxValue((_props$$mt = props.$mt) !== null && _props$$mt !== void 0 ? _props$$mt : props.$my);
}, function (props) {
  var _props$$mb;

  return pxValue((_props$$mb = props.$mb) !== null && _props$$mb !== void 0 ? _props$$mb : props.$my);
}, function (props) {
  return pxValue(props.$p);
}, function (props) {
  var _props$$pl;

  return pxValue((_props$$pl = props.$pl) !== null && _props$$pl !== void 0 ? _props$$pl : props.$px);
}, function (props) {
  var _props$$pr;

  return pxValue((_props$$pr = props.$pr) !== null && _props$$pr !== void 0 ? _props$$pr : props.$px);
}, function (props) {
  var _props$$pt;

  return pxValue((_props$$pt = props.$pt) !== null && _props$$pt !== void 0 ? _props$$pt : props.$py);
}, function (props) {
  var _props$$pb;

  return pxValue((_props$$pb = props.$pb) !== null && _props$$pb !== void 0 ? _props$$pb : props.$py);
}, function (props) {
  return props.$hidden ? 'none' : props.$d;
}, function (props) {
  return props.$f;
}, function (props) {
  return props.$column;
}, function (props) {
  return props.$row;
}, function (props) {
  return pxValue(props.$mw);
}, function (props) {
  return pxValue(props.$w);
}, function (props) {
  return pxValue(props.$h);
}, function (props) {
  return props.$align;
}, function (props) {
  return props.$alignSelf;
}, function (props) {
  return props.$justify;
}, function (props) {
  return props.$textAlign;
}, function (props) {
  return props.$overflow;
});
/**
 * Styled component reprensenting a div with display:flex.
 * Properties:
 *  - All the properties from Layout above +
 *  DEPRECATED - $align is deprecated in favour of $alignItems
 *  - $align (string): align-items
 *  - $alignItems (string): align-items
 *  - $justify (string): justify-content
 *  - $gap (number (in pixels) or string): gap
 *  - $fd (string): flex-direction
 *  - $fw (string): flex-wrap
 */

exports.Layout = Layout;

var Flex = _styledComponents["default"].div.withConfig({
  displayName: "PTTLayout__Flex",
  componentId: "sc-ffwty3-0"
})(["", ";display:flex;", ";justify-content:", ";gap:", ";flex-direction:", ";flex-wrap:", ";"], Layout, function (props) {
  var _props$$alignItems;

  return (props.$align || props.$alignItems) && "\n        align-items:  ".concat((_props$$alignItems = props.$alignItems) !== null && _props$$alignItems !== void 0 ? _props$$alignItems : props.$align, ";\n    ");
}, function (props) {
  return props.$justify;
}, function (props) {
  return pxValue(props.$gap);
}, function (props) {
  return props.$fd;
}, function (props) {
  return props.$fw;
});
/**
 * Styled component representing a div
 * Properties:
 *  - All the properties from Layout above
 */


exports.Flex = Flex;

var Box = _styledComponents["default"].div.withConfig({
  displayName: "PTTLayout__Box",
  componentId: "sc-ffwty3-1"
})(["", ";"], Layout);
/**
 * Styled component reprensenting a div with display:grid.
 * Properties:
 *  - All the properties from Layout above +
 *  - $columns (string): grid-template-columns
 *  - $rows (string): grid-template-rows
 *  DEPRECATED - $align is deprecated in favour of $alignItems
 *  - $align (string): align-items
 *  - $alignItems (string): align-items
 *  - $justify (string): justify-items
 *  - $gap (number (in pixels) or string): gap
 */


exports.Box = Box;

var Grid = _styledComponents["default"].div.withConfig({
  displayName: "PTTLayout__Grid",
  componentId: "sc-ffwty3-2"
})(["", ";display:grid;grid-template-columns:", ";grid-template-rows:", ";gap:", ";align-items:", ";align-items:", ";justify-items:", ";"], Layout, function (props) {
  return props.$columns;
}, function (props) {
  return props.$rows;
}, function (props) {
  return pxValue(props.$gap);
}, function (props) {
  return props.$align;
}, function (props) {
  var _props$$alignItems2;

  return (_props$$alignItems2 = props.$alignItems) !== null && _props$$alignItems2 !== void 0 ? _props$$alignItems2 : 'start';
}, function (props) {
  return props.$justify;
});
/**
 * Utility function that takes a props object and separate the "layout" props (that start with $) from above from the rest
 * of the props
 */


exports.Grid = Grid;

var getLayoutProps = function getLayoutProps(props) {
  var layoutProps = Object.keys(props).filter(function (p) {
    return p.startsWith('$');
  }).reduce(function (acc, p) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, p, props[p]));
  }, {});
  var otherProps = Object.keys(props).filter(function (p) {
    return !p.startsWith('$');
  }).reduce(function (acc, p) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, p, props[p]));
  }, {});
  return {
    layoutProps: layoutProps,
    otherProps: otherProps
  };
};

exports.getLayoutProps = getLayoutProps;

var pxValue = function pxValue(value) {
  if (typeof value === 'number') {
    return "".concat(value, "px");
  } else if (!value) {
    return undefined;
  }

  return value;
};

exports.pxValue = pxValue;